export default __webpack_public_path__ + "static/media/fakegirl.1740bbc3.png";